export enum JobApplicationType {
  SALES = 'SALES',
  GENERIC = 'GENERIC',
}
